import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { IMAGE_FILE, TemplateChooser, TemplateTabs } from '@shoflo/polymer';

import { filterByValidFileExtension } from 'utils/sourceFileHelper';
import { selectCurrentTemplateTab } from 'actions/Broadcast';

import { getEventMedia, getTemplates } from '@shoflo/studio-redux/actions';

import { EVENT, MEDIA } from 'constants/Tabs';

const TemplatesWrapper = ({
  title,
  onCancel,
  onSelectTemplate,
  mediaSources
}) => {
  const dispatch = useDispatch();

  const { broadcastTemplates, broadcastEventMedia, templateTabs } = useSelector(
    state => state
  );

  useEffect(() => {
    dispatch(getTemplates(title));
    dispatch(getEventMedia());
  }, [dispatch, title]);

  let { templates, isLoading } = broadcastTemplates;

  const onTabChanged = tab => {
    dispatch(selectCurrentTemplateTab(tab));
  };

  if (templateTabs.currentTab === EVENT) {
    isLoading = broadcastEventMedia.isLoading;
    templates = broadcastEventMedia.eventMedia;
  }

  return (
    <>
      <TemplateTabs
        onTabChanged={onTabChanged}
        currentTab={templateTabs.currentTab}
      />
      <TemplateChooser
        mediaSources={mediaSources}
        isLoading={isLoading}
        templates={
          title !== MEDIA
            ? filterByValidFileExtension(templates, IMAGE_FILE)
            : filterByValidFileExtension(templates)
        }
        onCancel={onCancel}
        onSelectTemplate={onSelectTemplate}
        isEventTemplate={templateTabs.currentTab === EVENT}
      />
    </>
  );
};

TemplatesWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSelectTemplate: PropTypes.func.isRequired,
  mediaSources: PropTypes.array
};

export default TemplatesWrapper;
